<template>
  <div :class="'col-sm-' + size">
    <div class="form-group">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterItem',
  props: ['size']
}
</script>
